import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import QRCode from "react-qr-code";
import { Rnd } from "react-rnd";
import { setbadgeJson, setSelectedElement } from "BadgeDesignAction";
import { BASE_IMAGES_URL, classNames } from "Constants";
import BadgeEditorHeader from "./badge-editor-header";
import BadgeElementDelete from "./badge-element-delete"; // Cross icon to delete (Selected badge element)
import InputLabelToggle from "./input-label-toggle"; // Cross icon to delete (Selected badge element)
import PrintPriview from "./print-preview"; // Print preview component
import {
  TopLeftHandle,
  TopRightHandle,
  BottomRightHandle,
  BottomLeftHandle,
} from "./handler/bottom-handles"; // Cross icon to delete (Selected badge element)

class BadgeTemplateEditorNew extends Component {
  constructor(props) {
    super(props);
    this.state = { isEditBarHidden: true };

    this.dragAreaRef = React.createRef();
    this.refEditorHeader = React.createRef();
    this.handleCustomEditorButtons = this.handleCustomEditorButtons.bind(this); // Bold itelic Underline
  }

  componentWillUnmount() {
    this.props.setSelectedElement(); // Clear selected badge element for style changes
    this.setState({ isEditBarHidden: true });
  }

  // On select any element, do required action
  _handleSelectedElement = (e, ele) => {
    e.preventDefault();
    e.stopPropagation();
    // console.log("element :- ", ele);

    this.props.setSelectedElement(ele); // Set selected badge element for style changes

    setTimeout(() => {
      this.refEditorHeader.resetColorPicker();
      this.setState({
        isEditBarHidden:
          ele.htmlType === "div" || ele.htmlType === "input" ? false : true,
      });
    }, 100);
  };

  /* Show actual data
    Example - #first_name -> Tapas
    'identifierString' as name => #name */
  showActulData = (identifierString) => {
    let text = "";
    let { eventDetails, userDetails } = this.props;

    if (identifierString === "#event_name") {
      text = eventDetails.eventname;
    } else if (identifierString === "#first_name" && userDetails.firstname) {
      text = userDetails.firstname;
    } else if (identifierString === "#last_name" && userDetails.lastname) {
      text = userDetails.lastname;
    } else if (identifierString === "#full_name" && userDetails.username) {
      text = userDetails.username;
    } else if (identifierString === "#designation" && userDetails.designation) {
      text = userDetails.designation;
    } else if (identifierString === "#company_name" && userDetails.company) {
      text = userDetails.company;
    } else if (
      identifierString === "#registration_type" &&
      userDetails.comesfrom
    ) {
      text = userDetails.comesfrom;
    } else if (
      identifierString === "#event_location" &&
      userDetails.eventlocation
    ) {
      text = userDetails.eventlocation;
    } else if (
      identifierString === "#primary_group" &&
      _.size(userDetails.usercategory_array)
    ) {
      let primaryGroupId = _.toString(
        _.split(userDetails.usercategory, ",", 1)
      ); // Example => 123546,7854123,498156 will take 123546
      let newPrimaryGroupArray = _.filter(userDetails.usercategory_array, {
        id: primaryGroupId,
      });
      text = newPrimaryGroupArray[0]?.groupname;
    } else {
      text = identifierString;
    }
    return text;
  };

  /* On Drag change element position */
  _handelCustomOnDrag = (element, d, id) => {
    let { templateJson, draggableElementNotMovied } = this.props;

    let arrIndex = _.findIndex(templateJson, function (o) {
      return o.id == id;
    });

    templateJson[arrIndex].x = d.x;
    templateJson[arrIndex].y = d.y;

    this.props.setbadgeJson(templateJson); // Update to store
    if (draggableElementNotMovied) {
      // detect element move for submit button disable
      this.props._handelDraggableElementChange(false);
    }
  };

  /* On Resize elements */
  _handelCustomonResize = (e, direction, ref, delta, position, item) => {
    let { templateJson, boxSize } = this.props;

    let arrIndex = _.findIndex(templateJson, function (o) {
      return o.id == item.id;
    });
    // console.log("ref :- ", ref);
    // console.log("boxwidth :- ", boxwidth);
    // console.log("boxheight :- ", boxheight);

    let newWidth = ref.offsetWidth;
    let newHeight = ref.offsetHeight;
    if (item.iscustom) {
      newWidth = ref.offsetWidth;
      newHeight = ref.offsetHeight;
    }

    // This logic is added to keep the exact image wight, height as per box width, height. 'ref.offsetWidth' & '.offsetHeight' never send number after decimal.
    let boxwidth = Math.floor(boxSize.width);
    let boxheight = Math.floor(boxSize.height);
    if (newWidth == boxwidth) {
      newWidth = boxSize.width;
    }
    if (newHeight == boxheight) {
      newHeight = boxSize.height;
    }

    templateJson[arrIndex].style.width = newWidth;
    templateJson[arrIndex].style.height = newHeight;
    templateJson[arrIndex].x = position.x;
    templateJson[arrIndex].y = position.y;

    this.props.setbadgeJson(templateJson); // Update to store
  };

  /* Render All draggable box elements */
  renderDraggable = () => {
    let { eventDetails, session, userDetails, selectedElement, templateJson } =
      this.props;

    let eventicon = "";
    let eventlocation = "";

    if (eventDetails.eventicon)
      eventicon = `${BASE_IMAGES_URL}/${eventDetails.eventicon}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;

    if (eventDetails.eventlocation) {
      eventlocation = eventDetails.eventlocation;
    }
    // console.log("templateJson :- ", templateJson);

    let item = _.map(templateJson, (value, index) => {
      var styleRnd = {};
      var styleElement = {};

      if (value.htmlType === "div" || value.htmlType === "input") {
        styleRnd = value.style;
      } else if (value.htmlType === "image" || value.htmlType === "zoominout") {
        // qr and image
        styleRnd.border = value.style.border;
        styleRnd.width = value.style.width;
        styleRnd.height = value.style.height;

        /* -2 for fit image(element) under rnd(maindraggble) */
        styleElement.width = "100%";
        styleElement.height = "100%";
      }

      if (selectedElement.name === value.name) {
        styleRnd["border"] = "1px solid rgb(119, 119, 125)";
      } else {
        styleRnd["border"] = "";
      }
      styleRnd["zIndex"] = 2000 + (templateJson.length - value.displayOrder); // This is used dynamic fo element z-indexing. Need to use this every where to print same badge

      return !value.hidden ? (
        !value.iscustom && value.htmlType === "image" ? (
          <Rnd
            key={`key_rnd_${index}`}
            style={styleRnd}
            bounds=".boundary"
            className="badge-box"
            size={{
              width: value.style.width,
              height: value.style.height,
            }}
            position={{
              x: value.x,
              y: value.y,
            }}
            onDragStop={(e, d) => {
              this._handelCustomOnDrag(e, d, value.id);
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
              this._handelCustomonResize(
                e,
                direction,
                ref,
                delta,
                position,
                value
              );
            }}
            resizeHandleComponent={
              selectedElement.name === value.name
                ? {
                    topLeft: <TopLeftHandle />,
                    topRight: <TopRightHandle />,
                    bottomLeft: <BottomLeftHandle />,
                    bottomRight: <BottomRightHandle />,
                  }
                : {}
            }
            onClick={(e) => this._handleSelectedElement(e, value)}
          >
            <div className="badge-element-action-button-container">
              {selectedElement.name === value.name ? (
                <BadgeElementDelete
                  classAsProp={"fa fa-trash badge-cross-icon"}
                  laveldata={value}
                />
              ) : (
                ""
              )}
            </div>
            <img
              id={value.name}
              name={value.name}
              src={eventicon}
              style={styleElement}
              draggable="false"
              alt={value.name}
            />
          </Rnd>
        ) : !value.iscustom && value.htmlType === "zoominout" ? (
          <Rnd
            key={`key_rnd_${index}`}
            style={styleRnd}
            bounds=".boundary"
            className="badge-box"
            size={{
              width: value.style.width,
              height: value.style.height,
            }}
            position={{
              x: value.x,
              y: value.y,
            }}
            onDragStop={(e, d) => {
              this._handelCustomOnDrag(e, d, value.id);
            }}
            lockAspectRatio={1}
            onResizeStop={(e, direction, ref, delta, position) => {
              this._handelCustomonResize(
                e,
                direction,
                ref,
                delta,
                position,
                value
              );
            }}
            resizeHandleComponent={
              selectedElement.name === value.name
                ? {
                    topLeft: <TopLeftHandle />,
                    topRight: <TopRightHandle />,
                    bottomLeft: <BottomLeftHandle />,
                    bottomRight: <BottomRightHandle />,
                  }
                : {}
            }
            onClick={(e) => this._handleSelectedElement(e, value)}
          >
            <div className="badge-element-action-button-container">
              {selectedElement.name === value.name ? (
                <BadgeElementDelete
                  classAsProp={"fa fa-trash badge-cross-icon"}
                  laveldata={value}
                />
              ) : (
                ""
              )}
            </div>
            <QRCode
              size={256}
              style={{
                height: "100%",
                maxWidth: "100%",
                width: "100%",
                padding: 7,
              }}
              value={
                userDetails.magiclink && userDetails.magiclink !== ""
                  ? userDetails.magiclink
                  : "appuser###encrypted###token"
              }
              viewBox={`0 0 256 256`}
            />
          </Rnd>
        ) : value.iscustom && value.htmlType === "image" ? (
          <Rnd
            key={`key_rnd_${index}`}
            style={styleRnd}
            bounds=".boundary"
            className="badge-box"
            size={{
              width: value.style.width,
              height: value.style.height,
            }}
            position={{
              x: value.x,
              y: value.y,
            }}
            onDragStop={(e, d) => {
              this._handelCustomOnDrag(e, d, value.id);
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
              this._handelCustomonResize(
                e,
                direction,
                ref,
                delta,
                position,
                value
              );
            }}
            resizeHandleComponent={
              selectedElement.name === value.name
                ? {
                    topLeft: <TopLeftHandle />,
                    topRight: <TopRightHandle />,
                    bottomLeft: <BottomLeftHandle />,
                    bottomRight: <BottomRightHandle />,
                  }
                : {}
            }
            onClick={(e) => this._handleSelectedElement(e, value)}
          >
            <div className="badge-element-action-button-container">
              {selectedElement.name === value.name ? (
                <BadgeElementDelete
                  classAsProp={"fa fa-trash badge-cross-icon"}
                  laveldata={value}
                />
              ) : (
                ""
              )}
            </div>
            <img
              id={value.name}
              name={value.name}
              src={`${BASE_IMAGES_URL}/${value.imageValue}?api_key=${session.apiKey}&session_token=${session.sessionToken}`}
              style={styleElement}
              draggable="false"
              alt={value.name}
            />
          </Rnd>
        ) : value.iscustom && value.htmlType === "input" ? (
          <Rnd
            key={`key_rnd_${index}`}
            style={styleRnd}
            bounds=".boundary"
            className="badge-box"
            enableResizing={false}
            size={{
              width:
                value.style.textAlign && value.style.textAlign === "center"
                  ? "100%"
                  : "auto",
              height: "auto",
            }}
            position={{
              x:
                value.style.textAlign && value.style.textAlign === "center"
                  ? 0
                  : value.x,
              y: value.y,
            }}
            onDragStop={(e, d) => {
              this._handelCustomOnDrag(e, d, value.id);
            }}
            onClick={(e) => this._handleSelectedElement(e, value)}
          >
            <div className="badge-element-action-button-container">
              {selectedElement.name === value.name ? (
                <>
                  <BadgeElementDelete
                    classAsProp={"fa fa-trash badge-cross-icon"}
                    laveldata={value}
                  />
                  <InputLabelToggle
                    classAsProp={`${
                      value.label ? "fa fa-pencil" : "fa fa-save"
                    } badge-toggle-icon`}
                    idAsProp={value.id}
                    dpOrderAsProps={value.displayOrder}
                  />
                </>
              ) : (
                ""
              )}
            </div>
            {value.label ? (
              <span
                // style={styleElement}
                style={{
                  ...styleElement,
                  ...(_.size(value.textValue) === 0 || value.textValue === " "
                    ? { padding: 10 }
                    : {}),
                }}
              >
                {_.size(value.textValue) === 0
                  ? this.showActulData(value.name)
                  : value.textValue}
              </span>
            ) : (
              <input
                className="move"
                style={{ border: "1px solid red !important" }}
                type="text"
                id={value.id}
                name={value.name}
                value={
                  _.size(value.textValue) === 0
                    ? this.showActulData(value.name)
                    : value.textValue
                }
                // value={value.textValue}
                onChange={(e) => {
                  this._handelInputTextValue(e, value.id);
                }}
              />
            )}
          </Rnd>
        ) : (
          <Rnd
            key={`key_rnd_${index}`}
            style={styleRnd}
            bounds=".boundary"
            className="badge-box"
            enableResizing={false}
            size={{
              width:
                value.style.textAlign && value.style.textAlign === "center"
                  ? "100%"
                  : "auto",
              height: "auto",
            }}
            position={{
              x:
                value.style.textAlign && value.style.textAlign === "center"
                  ? 0
                  : value.x,
              y: value.y,
            }}
            onDragStop={(e, d) => {
              this._handelCustomOnDrag(e, d, value.id);
            }}
            onClick={(e) => this._handleSelectedElement(e, value)}
          >
            <div className="badge-element-action-button-container">
              {selectedElement.name === value.name ? (
                <BadgeElementDelete
                  classAsProp={"fa fa-trash badge-cross-icon"}
                  laveldata={value}
                />
              ) : (
                ""
              )}
            </div>
            <span>{this.showActulData(value.name)}</span>
          </Rnd>
        )
      ) : null;
    });

    return item;
  };

  /***  Header part function ***/
  handleCustomEditorButtons = (e, param) => {
    let { selectedElement, templateJson } = this.props;
    // console.log("param :- ", param);

    if (selectedElement.name && selectedElement.name !== "") {
      _.forEach(templateJson, (value, index) => {
        // Discurd qr code and image element
        if (value.name !== "#qr_code" && value.name !== "#event_logo") {
          if (value.name === selectedElement.name) {
            if (param === "b") {
              value.style.fontWeight =
                value.style.fontWeight === "bold" ? "normal" : "bold";
            } else if (param === "i") {
              value.style.fontStyle =
                _.size(value.style.fontStyle) > 0 ? "" : "italic";
            } else if (param === "u") {
              value.style.textDecoration =
                _.size(value.style.textDecoration) > 0 ? "" : "underline";
            } else if (param === "text-align") {
              value.style.textAlign =
                _.size(value.style.textAlign) > 0 ? "" : "center";
            } else if (param === "text-transform") {
              let cap =
                value.style.textTransform &&
                value.style.textTransform === "uppercase"
                  ? "none"
                  : "uppercase";
              value.style.textTransform = cap;
            } else {
              // No code yet
            }
          }

          if (value.htmlType === "input") {
            value.label = true;
          }
        }
      });

      this.props.setbadgeJson(templateJson); // Update to store
    }
  };

  /* Chnage option for "Font-Size" and "Font-Family" and "Font-Weight" */
  optionSelect = (e, value, name) => {
    let { selectedElement, templateJson } = this.props;

    if (selectedElement.name && selectedElement.name !== "") {
      _.forEach(templateJson, (val, index) => {
        if (val.name === selectedElement.name) {
          if (name === "fontSize") {
            val.style.fontSize = value;
          } else if (name === "fontFamily") {
            val.style.fontFamily = value;
          } else if (name === "fontWeight") {
            val.style.fontWeight = value;
          } else if (name === "color") {
            val.style.color = value;
          } else {
            // No code
          }
        }

        if (val.htmlType === "input") {
          val.label = true;
        }
      });

      this.props.setbadgeJson(templateJson); // Update to store
    }
  };

  /* On input type value enter */
  _handelInputTextValue = (e, id) => {
    let { templateJson } = this.props;
    let arrIndex = _.findIndex(templateJson, function (o) {
      return o.id == id;
    });
    templateJson[arrIndex].textValue =
      e.target.value === "" ? " " : e.target.value;

    this.props.setbadgeJson(templateJson); // Update to store
  };

  render() {
    let { boxSize, selectedElement } = this.props;
    let { isEditBarHidden } = this.state;
    // console.log("selectedElement :- ", selectedElement);

    return (
      <div>
        {/* BADGE EDIT PART - HEADER - STARTS */}
        <div className="badge-editor-header">
          <div
            className={classNames(
              isEditBarHidden ? "hidden" : "vertical-align-center"
            )}
          >
            <BadgeEditorHeader
              optionSelect={this.optionSelect}
              handleCustomEditorButtons={this.handleCustomEditorButtons}
              ref={(ref) => (this.refEditorHeader = ref)}
            />
          </div>
        </div>
        {/* BADGE EDIT PART - HEADER - ENDS */}

        {/* Editor Part [STARTS] */}
        <div
          className="badge-canvas-container"
          onClick={(e) => {
            this._handleSelectedElement(e, {});
          }}
        >
          <div
            style={{
              height: boxSize.height,
              width: boxSize.width,
            }}
            className="boundary badge-boundary"
            ref={this.dragAreaRef}
            onClick={(e) => {
              this._handleSelectedElement(e, {});
            }}
          >
            {this.renderDraggable()}
          </div>
        </div>
        {/* Editor Part [ENDS] */}

        <PrintPriview
          boxSizeHeight={boxSize.height}
          boxSizeWidth={boxSize.width}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    templateJson: state.templateJson,
    selectedElement: state.selectedElement,
    eventDetails: state.userEventDetails,
    userDetails: state.userDetails ? state.userDetails : [],
  };
}

export default connect(mapStateToProps, {
  setbadgeJson,
  setSelectedElement,
})(BadgeTemplateEditorNew);
